// extracted by mini-css-extract-plugin
export var container = "_3v-0";
export var error = "_3v-9";
export var label = "_3v-5";
export var light = "_3v-6";
export var md = "_3v-3";
export var sm = "_3v-2";
export var thin = "_3v-8";
export var thinBold = "_3v-7";
export var vertical = "_3v-4";
export var xs = "_3v-1";